export default __webpack_public_path__ + "static/media/SlideEight.47d34cf1.png";